<template>
  <div class="honor">
    <div class="auto_1280">
      <div class="intro">
        <div class="fl">
          <div class="title">{{intro.title}}</div>
          <div class="txt" v-if="intro.content">{{intro.content}}</div>
        </div>
        <div class="fr">
          <img :src="intro.coverImg" alt="">
        </div>
      </div>
    </div>
    <div class="honor-list">
      <!-- <div class="auto_1280">
        <div class="swiper-container">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="( item, index ) in honorList" :key="index">
              <div class="pic bg_contain" :style="'background-image: url(' + item.coverImg + ')'"></div>
              <div class="tit dot">{{item.title}}</div>
            </div>
          </div>
        </div>
        <div class="platform"></div>
      </div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div> -->
      <div class="auto_1280">
        <!-- <ul class="ul clearfix">
          <li v-for="( item, index ) in honorList" :key="index">
            <div class="name dot">{{item.title}}</div>
          </li>
        </ul> -->
      </div>
    </div>
  </div>
</template>
<script>
// import Swiper from 'swiper'
import 'swiper/dist/css/swiper.css'
export default {
  name: 'Honor',
  data () {
    return {
      intro: {},
      honorList: [],
      articleTypeId: 19,
      lan: this.$store.state.isEn
    }
  },
  watch: {
    '$store.state.isEn' () {
      this.lan = this.$store.state.isEn
      this.init()
    }
  },
  mounted () {
    this.initId()
    this.init()
  },
  activated () {
    this.initId()
    this.initSwiper()
  },
  methods: {
    initId () {
      const self = this
      // let menuList
      // try {
      //   menuList = JSON.parse(localStorage.getItem('routeList'))
      // } catch (e) {
      //   console.log(e)
      // }
      // const id = parseInt(self.$route.query.columnId)
      // const index = self.$route.path.lastIndexOf('/')
      // const path = self.$route.path.substring(index + 1, self.$route.path.length)
      // menuList.forEach((item) => {
      //   if (id === item.id) {
      //     item.children.forEach((inner) => {
      //       if (inner.requestTo.toLowerCase() === path) {
      //         this.articleTypeId = inner.id
      //         this.$store.commit('changeId', inner.id)
      //       }
      //     })
      //   }
      // })
      self.$store.commit('changeId', self.articleTypeId)
    },
    init () {
      const self = this
      self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, tag: 'true', bLanguage: this.lan }, r => {
        self.intro = r.data[0]
      })
      // self.$api.post('api/benefitArticle/queryByParam', { articleTypeId: this.articleTypeId, current: 1, pageSize: 20, bLanguage: this.lan }, r => {
      //   self.honorList = r.data
      //   self.$nextTick(function () {
      //     self.initSwiper()
      //   })
      // })
    },
    initSwiper () {
      /* eslint-disable no-new */
      // new Swiper('.swiper-container', {
      //   slidesPerView: 3,
      //   slidesPerGroup: 1,
      //   loop: true,
      //   autoplay: 3000,
      //   speed: 1000,
      //   nextButton: '.honor-list .swiper-button-next',
      //   prevButton: '.honor-list .swiper-button-prev'
      // })
    }
  }
}
</script>
<style scoped>
.honor{padding: 2% 0 5%; position: relative; z-index: -1;}
.honor .fr{padding-top: 3%;}
.honor .fr img{width: 100%;}
.honor .title{font-size: 40px; color: #e4007f;}
.honor .txt{font-weight: lighter; color: #222; line-height: 2; padding-top: 5%; text-align: justify;}
.honor .honor-list{padding-top: 5%; position: relative;}
.honor .auto_1280{position: relative;}
.honor .pic{width: 100%; padding-top: 60%;}
.honor .swiper-slide{width: 33.3333%; padding: 0 20px;}
.honor .platform{width: 100%; padding-top: 30px; background: url(../../assets/platform.png)no-repeat center; background-size: cover; position: absolute; left: 0; bottom: 55px;}
.honor .tit{font-weight: lighter; text-align: center; color: #666; padding-top: 60px;}
.honor .swiper-button-prev,.honor .swiper-button-next{width: 50px; height: 50px; border-radius: 10px 0; border: 2px solid rgba(228,0,127,0.2);}
.honor .swiper-button-prev{background: url(../../assets/a_prev.png)no-repeat center; transition: all .3s; left: 5%; top: 50%;}
.honor .swiper-button-next{background: url(../../assets/a_next.png)no-repeat center; transition: all .3s; right: 5%; top: 50%;}
.honor .swiper-button-prev:hover{background: url(../../assets/a_prev_on.png)no-repeat center #e4007f;}
.honor .swiper-button-next:hover{background: url(../../assets/a_next_on.png)no-repeat center #e4007f;}

.honor ul{margin: 0 -1%;}
.honor li{float: left; width: 33%; padding: 0 1%; margin-top: 2%; text-align: center;}
.honor .name{line-height: 100px; padding: 0 2%; border-radius: 5px; border: 1px solid #f5f5f5; font-size: 20px; transition: all .3s;}
.honor .name:hover{border: 1px solid #e4007f; background-color: #e4007f; color: #fff;}
@media(max-width: 1280px){
  .honor .swiper-button-prev{background: url(../../assets/a_prev_on.png)no-repeat center #e4007f;}
  .honor .swiper-button-next{background: url(../../assets/a_next_on.png)no-repeat center #e4007f;}
}
@media(max-width: 768px){
  .honor .swiper-button-prev,.swiper-button-next{width: 40px; height: 40px;}
}
@media(max-width: 640px){
  .honor .fl{float: none; width: 100%; padding-top: 0;}
  .honor .txt{padding-top: 2%;}
  .honor .title{font-size: 30px;}
  .honor .fr{float: none; width: 100%; padding-top: 51.888%;}
}
</style>
